import { getIconString, ZIconType } from "../helpers/utility/iconMap";
import { Variant } from "react-bootstrap/esm/types";

type ZIconProps = {
    icon: ZIconType;
    variant?: Variant;
    label?: string;
    iconClassName?: string;
    style?: React.CSSProperties;
    size?: "12px" | "14px" | "18px" | "24px" | "36px" | "48px";
}

export const ZIcon = ({icon, variant, iconClassName, label, size, style }: ZIconProps) => {
    return (
        <span style={style} className={`d-inline-flex ${variant ? `text-${variant}` : ""} align-items-center ${iconClassName ? iconClassName : ""}`}><i className={`d-flex zicon ${getIconString(icon)} mdi-${size ?? "18px"} ${label && "me-1"}`}></i>{label}</span>
    );
}